import { render, staticRenderFns } from "./CheckIcon.vue?vue&type=template&id=4b84d3d2&"
import script from "./CheckIcon.vue?vue&type=script&lang=ts&"
export * from "./CheckIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4b84d3d2', component.options)
    } else {
      api.reload('4b84d3d2', component.options)
    }
    module.hot.accept("./CheckIcon.vue?vue&type=template&id=4b84d3d2&", function () {
      api.rerender('4b84d3d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/CheckIcon.vue"
export default component.exports